import { render } from "./public_timeline.vue?vue&type=template&id=5f2a502e"
import script from "./public_timeline.js?vue&type=script&lang=js"
export * from "./public_timeline.js?vue&type=script&lang=js"

import exportComponent from "/woodpecker/src/akkoma.dev/AkkomaGang/akkoma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__